import React, { useEffect, useMemo, useRef, useState } from 'react'
import Header from '../../../components/Header'
import { Box, Button, Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, InputAdornment, MenuItem, Select, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useMediaQuery, useTheme } from '@mui/material'
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom'
import EditIcon from '@mui/icons-material/Edit';
import { format } from 'date-fns';
import { getAllDataForCommercialmarket, getDispatchProcess, getProcesskitproduct } from '../../../redux/slice/dispatchProcess.slice';
import SearchIcon from '@mui/icons-material/Search';
import PrintIcon from '@mui/icons-material/Print';
import Checkbox from '@mui/material/Checkbox';

import pdfFonts from "pdfmake/build/vfs_fonts";
import { useDispatch, useSelector } from 'react-redux';

import pdfMake from "pdfmake/build/pdfmake";
import LexendBold from "../../../fonts/Lexend-Bold.ttf";
import LexendRegular from "../../../fonts/Lexend-Regular.ttf";
import { useCallback } from 'react';
pdfMake.vfs = pdfFonts.pdfMake.vfs; // Use default vfs as a base

const getLexendFonts = async () => {
    const fetchFont = async (fontPath) => {
        const response = await fetch(fontPath);
        const buffer = await response.arrayBuffer();
        return bufferToBase64(buffer);
    };

    const regularFont = await fetchFont(LexendRegular);
    const boldFont = await fetchFont(LexendBold);

    pdfMake.vfs['Lexend-Regular.ttf'] = regularFont;
    pdfMake.vfs['Lexend-Bold.ttf'] = boldFont;

    pdfMake.fonts = {
        Lexend: {
            normal: 'Lexend-Regular.ttf',
            bold: 'Lexend-Bold.ttf',
        },
    };
};

const bufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

const getBase64Image = (img) => {
    return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = () => {
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0);
            const dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
        };
        image.src = img;
    });
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => {
    const isVerySmallScreen = useMediaQuery('(max-width:425px)');
    const isMediumScreen = useMediaQuery('(min-width:426px) and (max-width:1024px)');
    return {
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: isVerySmallScreen ? 12 : (isMediumScreen ? 15 : 25),
            left: isVerySmallScreen ? 'calc(-50% + 12px)' : (isMediumScreen ? 'calc(-50% + 15px)' : 'calc(-50% + 25px)'),
            right: isVerySmallScreen ? 'calc(50% + 12px)' : (isMediumScreen ? 'calc(50% + 15px)' : 'calc(50% + 25px)'),
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundImage: 'linear-gradient( 95deg,#134670 0%, #2B89D5 120%)',
            },
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundImage: 'linear-gradient( 95deg,#134670 0%, #2B89D5 120%)',
            },
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: isVerySmallScreen ? 2 : 3,
            border: 0,
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#b9b9b9',
            borderRadius: 1,
        },
    };
});

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState, isMobile, isVerySmallScreen }) => ({
    backgroundColor: ownerState.completed ? '#134670' : '#fff',
    zIndex: 1,
    color: ownerState.completed ? '#fff' : '#000',
    width: isVerySmallScreen ? 30 : (isMobile ? 30 : 50),
    height: isVerySmallScreen ? 30 : (isMobile ? 30 : 50),
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
}));

function ColorlibStepIcon(props) {
    const { active, completed, className, icon } = props;
    const isVerySmallScreen = useMediaQuery('(max-width:425px)');
    const isMediumScreen = useMediaQuery('(min-width:426px) and (max-width:1024px)');
    const stepNumber = String(icon);
    return (
        <ColorlibStepIconRoot
            ownerState={{ completed, active }}
            className={className}
            isMobile={isVerySmallScreen || isMediumScreen}
            isVerySmallScreen={isVerySmallScreen}
        >
            <Typography
                variant={isVerySmallScreen ? "body2" : (isMediumScreen ? "body2" : "h4")}
                style={{ fontWeight: 'bold', color: completed ? '#fff' : '#000' }}
            >
                {stepNumber}
            </Typography>
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
    icon: PropTypes.node,
    onClick: PropTypes.func,
};

const steps = ['Dispatch on Credit', 'Dispatch Pending', 'Half Material Dispatch', 'Dispatch Done'];

const DispatchProcess = () => {
    const navigate = useNavigate()
    const theme = useTheme();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width:1024px)');
    const isMobileee = useMediaQuery('(max-width:500px)');

    const [activeStep, setActiveStep] = React.useState(0);
    const AllDispatchProcess = useSelector((state) => state.dispatchProcess.dispatchProcess);
    const Market = useSelector(state => state.dispatchProcess.commercialMarket)
    const allLiasoning = useMemo(() =>
        Market.map(market => market?.liasoningData).filter(Boolean).flat(),
        [Market]);
    const filteredLiasoning = useMemo(() =>
        allLiasoning.map(({ fillNo, filledSteps }) => ({ fillNo, filledSteps })),
        [allLiasoning]);


    // const fMarket = useMemo(() =>
    //     Market.filter(marketdata =>
    //         (!marketdata.statusL || marketdata.statusL === "Disabled") &&
    //         allLiasoning.find(l => l.fillNo === marketdata.fillNo)?.filledSteps?.includes("1")
    //     ),
    //     [Market, allLiasoning]);

    const fMarket = useMemo(() =>
        Market.filter(marketdata => {
            const statusCheck = (!marketdata.statusL || marketdata.statusL === "Disabled");

            // If system size < 6, do NOT check liasoning filledSteps
            if (marketdata.SystemSizeKw < 6) {
                return statusCheck;
            }

            // For >= 6 kW, must also check liasoning filledSteps contains "1"
            const filledStep1 = allLiasoning
                .find(l => l.fillNo === marketdata.fillNo)
                ?.filledSteps?.includes("1");

            return statusCheck && filledStep1;
        }),
        [Market, allLiasoning]
    );



    console.log("allLiasoning", allLiasoning, Market);

    const fMarket0 = useSelector(state =>
        state.dispatchProcess.commercialMarket
            .filter(marketdata => {
                const liasoningData = allLiasoning.find(l => l.fillNo === marketdata.fillNo);
                return liasoningData?.filledSteps?.includes("0") && !liasoningData?.filledSteps?.includes("1");
            })
            .map(x => x.fillNo)
    );


    // console.log("fMarketfMarketfMarket000",fMarket0)
    // console.log("fMarketfMarketfMarket111",fMarket)

    const kitproductdata = useSelector(state => state.dispatchProcess.kitproduct)

    useEffect(() => {
        getLexendFonts();
    }, []);




    useEffect(() => {
        dispatch(getAllDataForCommercialmarket())
        dispatch(getDispatchProcess())
        dispatch(getProcesskitproduct())
    }, [dispatch])

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleEdit = (marketdata, dispatchProcessId) => {
        navigate('/admin/add-dispatch-process', { state: { marketdata, dispatchProcessId } });
    };


    const MobileStepper = ({ steps, activeStep, completedSteps }) => {
        const isVerySmallScreen = useMediaQuery('(max-width:425px)');
        const isMediumScreen = useMediaQuery('(min-width:426px) and (max-width:1024px)');

        if (isVerySmallScreen) {
            const firstRowSteps = steps.slice(0, 5);
            const renderStepper = (stepArray, startIndex) => (
                <Stepper alternativeLabel activeStep={activeStep - startIndex} connector={<ColorlibConnector />}>
                    {stepArray.map((label, index) => {
                        const stepNumber = index + 1 + startIndex;
                        const isStepCompleted = completedSteps[stepNumber];
                        return (
                            <Step key={label} completed={isStepCompleted}>
                                <StepLabel
                                    StepIconComponent={ColorlibStepIcon}
                                    StepIconProps={{
                                        completed: isStepCompleted,
                                        icon: stepNumber
                                    }}
                                >
                                    <Typography style={{
                                        color: isStepCompleted ? theme.palette.mode === 'dark' ? '#6da2cd' : "#165e99" : theme.palette.text.primary,
                                        fontWeight: '600'
                                    }}>
                                        {label}
                                    </Typography>
                                </StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
            );

            return (
                <Box>
                    {renderStepper(firstRowSteps, 0)}
                    <Box sx={{ my: 1 }} />

                </Box>
            );
        } else if (isMediumScreen) {
            const firstRowSteps = steps.slice(0, 5);
            const renderStepper = (stepArray, startIndex) => (
                <Stepper alternativeLabel activeStep={activeStep - startIndex} connector={<ColorlibConnector />}>
                    {stepArray.map((label, index) => {
                        const stepNumber = index + 1 + startIndex;
                        const isStepCompleted = completedSteps[stepNumber];
                        return (
                            <Step key={label} completed={isStepCompleted}>
                                <StepLabel
                                    StepIconComponent={ColorlibStepIcon}
                                    StepIconProps={{
                                        completed: isStepCompleted,
                                        icon: stepNumber
                                    }}
                                >
                                    <Typography style={{
                                        color: isStepCompleted ? theme.palette.mode === 'dark' ? '#6da2cd' : "#165e99" : theme.palette.text.primary,
                                        fontWeight: '600'
                                    }}>
                                        {label}
                                    </Typography>
                                </StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
            );

            return (
                <Box>
                    {renderStepper(firstRowSteps, 0)}
                    <Box sx={{ my: 1 }} />
                </Box>
            );
        }
        return null;
    };

    const getPaymentStatus = useCallback((marketdata) => {
        const accountPayment = marketdata.AccountData?.[0];
        if (accountPayment) {
            const totalPayment = accountPayment.AccountDetails?.reduce((sum, detail) => sum + Number(detail.AccountAmount), 0);
            const totalAmount = Number(marketdata.TotalAmount);
            const halfAmount = totalAmount / 2;
            if (totalPayment >= halfAmount) {
                return 'partial';
            }
            if (totalPayment >= totalAmount) {
                return 'full';
            }
        }
        return 'none';
    }, []);;




    const getCompletedSteps = (marketdata) => {
        // console.log("marketdata", marketdata?._id, AllDispatchProcess);
        let stepStatus = {
            1: true,
            2: false,
            3: false,
            4: false
        };
        const paymentStatus = getPaymentStatus(marketdata);
        if (paymentStatus === 'partial' || paymentStatus === 'full') {
            stepStatus[2] = true;
        }
        const dispatchProcess = AllDispatchProcess.find(process => process?.marketId === marketdata?._id);
        if (dispatchProcess) {
            stepStatus[3] = true;
        }

        if (filteredLiasoning.find(l => l.fillNo === marketdata.fillNo)?.filledSteps?.includes("6") && dispatchProcess) {
            stepStatus[4] = true;
        }
        return stepStatus;
    };
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const [selectedStatus, setSelectedStatus] = useState("0");

    const doesMarketMatchSearch = (v, searchString, AllDispatchProcess) => {
        const dispatchProcess = AllDispatchProcess.find(process => process.marketId === v._id);
        const dispatchNumbers = dispatchProcess?.ProcessData?.map(data => data.generatedNumber).join(', ') || '';
        const warehouse = dispatchProcess?.ProcessData?.map(data => data.DebitCreditWarehouseData?.wareHouseName).join(', ') || '';
        const purposeOfDispatch = dispatchProcess?.ProcessData?.map(data => data.PurposeofDispatch).join(', ') || '';
        const DispatchDate = dispatchProcess?.ProcessData?.map(data => {
            if (data.DispatchDate !== "") {
                const date = new Date(data.DispatchDate);
                return format(date, 'dd-MM-yyyy');
            }
        }).join(', ') || '';

        const accountDetails = v.AccountData?.[0]?.AccountDetails || [];
        const totalAccountAmount = accountDetails.reduce(
            (sum, account) => sum + parseFloat(account.AccountAmount || 0),
            0
        );
        const remainingAmount = parseFloat(v.TotalAmount || 0) - totalAccountAmount;

        return (
            v.ConsumerName?.toLowerCase().includes(searchString) ||
            v.fillNo?.toLowerCase().includes(searchString) ||
            v.SystemSizeKw?.toLowerCase().includes(searchString) ||
            v.Address?.toLowerCase().includes(searchString) ||
            v.City_Village?.toLowerCase().includes(searchString) ||
            v.userData?.[0]?.name?.toLowerCase()?.includes(searchString) ||
            warehouse.toLowerCase().includes(searchString) ||
            DispatchDate.toLowerCase().includes(searchString) ||
            purposeOfDispatch.toLowerCase().includes(searchString) ||
            dispatchNumbers.toLowerCase().includes(searchString) ||
            remainingAmount.toString().includes(searchString) ||
            (remainingAmount <= 0 && "Fully Paid".toLowerCase().includes(searchString))
        );
    };

    const statusCounts = useMemo(() => {
        const counts = {
            "Dispatch on Credit": 0,
            "Dispatch Pending": 0,
            "Half Material Dispatch": 0,
            "Dispatch Done": 0
        };

        const searchString = searchTerm?.toLowerCase() || '';

        fMarket.forEach((v) => {
            // Apply search filter
            if (searchString && !doesMarketMatchSearch(v, searchString, AllDispatchProcess)) {
                return; // skip this entry
            }

            const completedSteps = getCompletedSteps(v);

            if (completedSteps[4]) {
                counts["Dispatch Done"]++;
            } else if (completedSteps[3]) {
                counts["Half Material Dispatch"]++;
            } else if (completedSteps[2]) {
                counts["Dispatch Pending"]++;
            } else if (completedSteps[1]) {
                counts["Dispatch on Credit"]++;
            }
        });

        return counts;
    }, [fMarket, searchTerm, AllDispatchProcess]);



    const filteredMarket = useMemo(() => {
        const searchString = searchTerm?.toLowerCase() || '';
        return fMarket.filter(v => {
            const completedSteps = getCompletedSteps(v);

            // First check status
            let statusMatch = false;
            switch (selectedStatus) {
                case "0":
                    statusMatch = true;
                    break;
                case "Dispatch on Credit":
                    statusMatch = completedSteps[1] && !completedSteps[2] && !completedSteps[3];
                    break;
                case "Dispatch Pending":
                    statusMatch = completedSteps[2] && !completedSteps[3];
                    break;
                case "Half Material Dispatch":
                    statusMatch = completedSteps[3] && !completedSteps[4];
                    break;
                case "Dispatch Done":
                    statusMatch = completedSteps[4];
                    break;
                default:
                    statusMatch = true;
            }

            if (!statusMatch) return false;

            // Then check search
            if (!searchString) return true;

            return doesMarketMatchSearch(v, searchString, AllDispatchProcess);
        });
    }, [fMarket, selectedStatus, searchTerm, AllDispatchProcess]);



    // const statusCounts = useMemo(() => {
    //     const counts = {
    //         "Dispatch on Credit": 0,
    //         "Dispatch Pending": 0,
    //         "Half Material Dispatch": 0,
    //         "Dispatch Done": 0
    //     };

    //     fMarket.forEach(v => {
    //         // Search filtering
    //         const dispatchProcess = AllDispatchProcess.find(process => process.marketId === v._id);
    //         const dispatchNumbers = dispatchProcess?.ProcessData?.map(data => data.generatedNumber).join(', ') || '';
    //         const warehouse = dispatchProcess?.ProcessData?.map(data => data.DebitCreditWarehouseData?.wareHouseName).join(', ') || '';
    //         const purposeOfDispatch = dispatchProcess?.ProcessData?.map(data => data.PurposeofDispatch).join(', ') || '';
    //         const DispatchDate = dispatchProcess?.ProcessData?.map(data => {
    //             if (data.DispatchDate !== "") {
    //                 const date = new Date(data.DispatchDate);
    //                 return format(date, 'dd-MM-yyyy');
    //             }
    //         }).join(', ') || '';

    //         const searchString = searchTerm?.toLowerCase() || '';
    //         const accountDetails = v.AccountData?.[0]?.AccountDetails || [];
    //         const totalAccountAmount = accountDetails.reduce(
    //             (sum, account) => sum + parseFloat(account.AccountAmount || 0),
    //             0
    //         );
    //         const remainingAmount = parseFloat(v.TotalAmount || 0) - totalAccountAmount;

    //         const matchesSearch = !searchString || (
    //             v.ConsumerName?.toLowerCase().includes(searchString) ||
    //             v.fillNo?.toLowerCase().includes(searchString) ||
    //             v.SystemSizeKw?.toLowerCase().includes(searchString) ||
    //             v.Address?.toLowerCase().includes(searchString) ||
    //             v.City_Village?.toLowerCase().includes(searchString) ||
    //             v.userData?.[0]?.name?.toLowerCase()?.includes(searchString) ||
    //             warehouse.toLowerCase().includes(searchString) ||
    //             DispatchDate.toLowerCase().includes(searchString) ||
    //             purposeOfDispatch.toLowerCase().includes(searchString) ||
    //             dispatchNumbers.toLowerCase().includes(searchString) ||
    //             remainingAmount.toString().includes(searchString) ||
    //             (remainingAmount <= 0 && "Fully Paid".toLowerCase().includes(searchString))
    //         );

    //         if (!matchesSearch) return; // skip if not matching search

    //         // Status filtering
    //         const completedSteps = getCompletedSteps(v);
    //         if (completedSteps[4]) {
    //             counts["Dispatch Done"]++;
    //         } else if (completedSteps[3] && !completedSteps[4]) {
    //             counts["Half Material Dispatch"]++;
    //         } else if (completedSteps[2] && !completedSteps[3]) {
    //             counts["Dispatch Pending"]++;
    //         } else if (completedSteps[1] && !completedSteps[2]) {
    //             counts["Dispatch on Credit"]++;
    //         }
    //     });

    //     return counts;
    // }, [fMarket, searchTerm, AllDispatchProcess]);


    // const statusCounts = useMemo(() => {
    //     const counts = {
    //         "Dispatch on Credit": 0,
    //         "Dispatch Pending": 0,
    //         "Half Material Dispatch": 0,
    //         "Dispatch Done": 0
    //     };

    //     fMarket.forEach(v => {
    //         const completedSteps = getCompletedSteps(v);
    //         if (completedSteps[4]) {
    //             counts["Dispatch Done"]++;
    //         } else if (completedSteps[3] && !completedSteps[4]) {
    //             counts["Half Material Dispatch"]++;
    //         } else if (completedSteps[2] && !completedSteps[3]) {
    //             counts["Dispatch Pending"]++;
    //         } else if (completedSteps[1] && !completedSteps[2]) {
    //             counts["Dispatch on Credit"]++;
    //         }
    //     });

    //     return counts;
    // }, [fMarket]);  // Only recalc when fMarket changes



    // const filteredMarket = useMemo(() => {
    //     return fMarket.filter(v => {
    //         if (selectedStatus === "0") {
    //             const searchString = searchTerm?.toLowerCase();
    //             const dispatchProcess = AllDispatchProcess.find(process => process.marketId === v._id);
    //             const dispatchNumbers = dispatchProcess?.ProcessData?.map(data => data.generatedNumber).join(', ') || '';
    //             const warehouse = dispatchProcess?.ProcessData?.map((data) => data.DebitCreditWarehouseData?.wareHouseName).join(', ')
    //             const purposeOfDispatch = dispatchProcess?.ProcessData?.map(data => data.PurposeofDispatch).join(', ') || '';
    //             const DispatchDate = dispatchProcess?.ProcessData?.map(data => {

    //                 if (data.DispatchDate !== "") {
    //                     const date = new Date(data.DispatchDate);
    //                     return format(date, 'dd-MM-yyyy');
    //                 }

    //             }).join(', ') || '';
    //             return (
    //                 v.ConsumerName.toLowerCase().includes(searchString) ||
    //                 v.fillNo.toLowerCase().includes(searchString) ||
    //                 v.SystemSizeKw.toLowerCase().includes(searchString) ||
    //                 v.Address.toLowerCase().includes(searchString) ||
    //                 v.City_Village.toLowerCase().includes(searchString) ||
    //                 v.userData[0]?.name.toLowerCase().includes(searchString) ||
    //                 warehouse?.toLowerCase()?.includes(searchString) |
    //                 DispatchDate.toLowerCase().includes(searchString) ||
    //                 purposeOfDispatch.toLowerCase().includes(searchString) ||
    //                 dispatchNumbers.toLowerCase().includes(searchString) ||
    //                 (() => {
    //                     const accountDetails = v.AccountData?.[0]?.AccountDetails || [];
    //                     const totalAccountAmount = accountDetails.reduce(
    //                         (sum, account) => sum + parseFloat(account.AccountAmount || 0),
    //                         0
    //                     );
    //                     const remainingAmount = parseFloat(v.TotalAmount || 0) - totalAccountAmount;
    //                     return (
    //                         remainingAmount.toString().includes(searchString) ||
    //                         (remainingAmount <= 0 && "Fully Paid".toLowerCase().includes(searchString))
    //                     );
    //                 })()
    //             );
    //         } else {
    //             const completedSteps = getCompletedSteps(v);
    //             switch (selectedStatus) {
    //                 case "Dispatch on Credit":
    //                     return (
    //                         completedSteps[1] &&
    //                         !completedSteps[2] &&
    //                         !completedSteps[3] // prevent overlap
    //                     );

    //                 case "Dispatch Pending":
    //                     return completedSteps[2] && !completedSteps[3];

    //                 case "Half Material Dispatch":
    //                     return completedSteps[3] && !completedSteps[4];

    //                 case "Dispatch Done":
    //                     return completedSteps[4];

    //                 default:
    //                     return true;
    //             }

    //         }
    //     });
    // }, [fMarket, selectedStatus, searchTerm, AllDispatchProcess]);

    //     const filteredMarket = useMemo(() => {
    //     return fMarket.filter(v => {
    //         const dispatchProcess = AllDispatchProcess.find(process => process.marketId === v._id);
    //         const dispatchNumbers = dispatchProcess?.ProcessData?.map(data => data.generatedNumber).join(', ') || '';
    //         const warehouse = dispatchProcess?.ProcessData?.map(data => data.DebitCreditWarehouseData?.wareHouseName).join(', ') || '';
    //         const purposeOfDispatch = dispatchProcess?.ProcessData?.map(data => data.PurposeofDispatch).join(', ') || '';
    //         const DispatchDate = dispatchProcess?.ProcessData?.map(data => {
    //             if (data.DispatchDate !== "") {
    //                 const date = new Date(data.DispatchDate);
    //                 return format(date, 'dd-MM-yyyy');
    //             }
    //         }).join(', ') || '';

    //         // First: Status filtering
    //         const completedSteps = getCompletedSteps(v);
    //         let statusMatch = false;

    //         switch (selectedStatus) {
    //             case "0":
    //                 statusMatch = true;
    //                 break;
    //             case "Dispatch on Credit":
    //                 statusMatch = completedSteps[1] && !completedSteps[2] && !completedSteps[3];
    //                 break;
    //             case "Dispatch Pending":
    //                 statusMatch = completedSteps[2] && !completedSteps[3];
    //                 break;
    //             case "Half Material Dispatch":
    //                 statusMatch = completedSteps[3] && !completedSteps[4];
    //                 break;
    //             case "Dispatch Done":
    //                 statusMatch = completedSteps[4];
    //                 break;
    //             default:
    //                 statusMatch = true;
    //         }

    //         if (!statusMatch) return false;

    //         // Then: Search filtering
    //         const searchString = searchTerm?.toLowerCase() || '';
    //         if (!searchString) return true; // No search term, match by default

    //         const accountDetails = v.AccountData?.[0]?.AccountDetails || [];
    //         const totalAccountAmount = accountDetails.reduce(
    //             (sum, account) => sum + parseFloat(account.AccountAmount || 0),
    //             0
    //         );
    //         const remainingAmount = parseFloat(v.TotalAmount || 0) - totalAccountAmount;

    //         return (
    //             v.ConsumerName?.toLowerCase().includes(searchString) ||
    //             v.fillNo?.toLowerCase().includes(searchString) ||
    //             v.SystemSizeKw?.toLowerCase().includes(searchString) ||
    //             v.Address?.toLowerCase().includes(searchString) ||
    //             v.City_Village?.toLowerCase().includes(searchString) ||
    //             v.userData?.[0]?.name?.toLowerCase()?.includes(searchString) ||
    //             warehouse.toLowerCase().includes(searchString) ||
    //             DispatchDate.toLowerCase().includes(searchString) ||
    //             purposeOfDispatch.toLowerCase().includes(searchString) ||
    //             dispatchNumbers.toLowerCase().includes(searchString) ||
    //             remainingAmount.toString().includes(searchString) ||
    //             (remainingAmount <= 0 && "Fully Paid".toLowerCase().includes(searchString))
    //         );
    //     });
    // }, [fMarket, selectedStatus, searchTerm, AllDispatchProcess]);

    const orderDetails = {
        billTo: {
            companyName: 'Tvarit Energy LLP.',
            address: '707 - Twin Star, North Block, Near Nana Mava Circle, 150 Ft Ring Road, Rajkot, Gujarat - 360005',
            gst: '24AAQFT9592E1ZK',
            contactNumber: '+91 97245 71843',
            email: 'info@tvaritenergy.in',
            website: 'www.tvaritenergy.in',
        },
    };

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const [dispatchProcessId, setDispatchProcessId] = useState(null);

    const printRef = useRef();

    const handlePrint = (v, dispatchProcessId) => {
        setDispatchProcessId(dispatchProcessId);
        setSelectedPurchase(v);
        setOpenDialog(true);
        const bulkIds = AllDispatchProcess.find(process => process._id === dispatchProcessId)?.bulkId;
        const bulkfiltered = AllDispatchProcess.filter(process => process.bulkId === bulkIds);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const generatePdfContent = async (selectedPurchase, matchingDispatchProcess) => {


        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.fonts = {
            Lexend: {
                normal: 'Lexend-Regular.ttf',
                bold: 'Lexend-Bold.ttf',
            }
        };

        const logoSrc = theme.palette.mode === "dark" ? '../../assets/images/logo/logo.svg' : '../../assets/images/logo/logo.svg';
        const logoBase64 = await getBase64Image(logoSrc);
        const stampImg = await getBase64Image("../../assets/images/stamp/stamp.svg")
        const allPagesContent = [];
        matchingDispatchProcess?.ProcessData?.forEach((processItem, index) => {
            if (index > 0) {
                allPagesContent.push({ text: '', pageBreak: 'before' });
            }

            allPagesContent.push(
                {
                    columns: [
                        {
                            image: logoBase64,
                            width: 100,
                            margin: [0, 0, 0, 0]
                        },
                        {
                            text: matchingDispatchProcess?.ProcessData?.[index]?.generatedNumber.includes('Return') ? 'RETURN CHALLAN' : 'DISPATCH CHALLAN',
                            style: 'header',
                            alignment: 'right',
                            margin: [0, 0, 0, 2],
                            decoration: 'underline',
                            decorationColor: '#FB9822',
                            fontSize: 16,
                            characterSpacing: 2
                        },

                    ],
                },

                {
                    table: {
                        widths: ['50%'],
                        body: [
                            []
                        ]
                    },
                    margin: [0, 20, 0, 0]
                },
                {

                    columns: [
                        {
                            width: '48%',
                            table: {
                                widths: ['100%'],
                                body: [
                                    [{
                                        fillColor: '#1A2B4F',
                                        color: '#FFFFFF',
                                        text: 'CUSTOMER DETAILS',
                                        bold: true,
                                        fontSize: 11,
                                        margin: [5, 5],
                                        characterSpacing: 2
                                    }]
                                ]
                            }
                        },

                        { width: '4%', text: '' },
                        {
                            width: '48%',
                            table: {
                                widths: ['32%', '2%', '66%'],
                                body: [
                                    [
                                        { text: 'Dispatch No', bold: true, fontSize: 9, border: [false, false, false, false] },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: matchingDispatchProcess?.ProcessData?.[index]?.generatedNumber || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ],
                                    [
                                        { text: 'Date', bold: true, fontSize: 9, border: [false, false, false, false] },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: format(new Date(matchingDispatchProcess?.ProcessData?.[index]?.DispatchDate), 'dd-MM-yyyy') || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ]
                                ]
                            },
                            layout: {
                                hLineWidth: function (i, node) {
                                    return (i === 0 || i === node.table.body.length) ? 0 : 0;
                                },
                                vLineWidth: function (i, node) {
                                    return 0;
                                },
                            }
                        }
                    ],
                    margin: [0, 20, 0, 20]
                },
                {
                    columns: [
                        {
                            width: '48%',
                            table: {
                                widths: ['42%', '2%', '56%'], // Changed widths
                                body: [
                                    [
                                        { text: 'Customer Name', border: [false, false, false, false], fontSize: 9 },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: selectedPurchase?.ConsumerName + ' (' + selectedPurchase?.fillNo + ')' || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ],
                                    [
                                        { text: 'Customer Address', border: [false, false, false, false], fontSize: 9 },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: selectedPurchase?.Address || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ],
                                    [
                                        { text: 'Customer Mobile No', border: [false, false, false, false], fontSize: 9 },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: selectedPurchase?.PhoneNumber || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ]
                                ]
                            },
                            layout: {
                                hLineWidth: function (i, node) {
                                    return (i === 0 || i === node.table.body.length) ? 0 : 0;
                                },
                                vLineWidth: function (i, node) {
                                    return 0;
                                },
                            }
                        }
                    ]
                },
                {
                    columns: [
                        {
                            width: '48%',
                            table: {
                                widths: ['100%'],
                                body: [
                                    [{
                                        fillColor: '#1A2B4F',
                                        color: '#FFFFFF',
                                        text: 'TVARIT ADDRESS',
                                        bold: true,
                                        fontSize: 11,
                                        margin: [5, 5],
                                        characterSpacing: 2
                                    }]
                                ]
                            }
                        },
                        { width: '4%', text: '' },
                        {
                            width: '48%',
                            table: {
                                widths: ['100%'],
                                body: [
                                    [{
                                        fillColor: '#1A2B4F',
                                        color: '#FFFFFF',
                                        text: 'SHIP FROM',
                                        bold: true,
                                        fontSize: 11,
                                        margin: [5, 5],
                                        characterSpacing: 2
                                    }]
                                ]
                            }
                        }
                    ],
                    margin: [0, 20, 0, 20]
                },

                {
                    columns: [
                        {
                            width: '48%',
                            stack: [
                                {
                                    table: {
                                        widths: ['42%', '2%', '56%'],
                                        body: [
                                            [
                                                { text: 'Company Name', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.companyName, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Address', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.address, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'GST No', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.gst, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Contact No', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.contactNumber, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Email', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.email, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Website', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.website, border: [false, false, false, false], fontSize: 9 }
                                            ]
                                        ]
                                    },
                                    layout: {
                                        defaultBorder: false,
                                        paddingLeft: function (i) { return 4; },
                                        paddingRight: function (i) { return 4; },
                                        paddingTop: function (i) { return 4; },
                                        paddingBottom: function (i) { return 4; }
                                    }
                                }
                            ]
                        },
                        { width: '4%', text: '' },
                        {
                            width: '48%',
                            stack: [
                                {
                                    table: {
                                        widths: ['42%', '2%', '56%'],
                                        body: [
                                            [
                                                { text: 'Company Name', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                {
                                                    text: (() => {
                                                        if (!matchingDispatchProcess?.ProcessData?.[index]) return 'N/A';
                                                        const warehouseName = matchingDispatchProcess.ProcessData[index]?.DebitCreditWarehouseData?.wareHouseName || 'N/A';
                                                        return warehouseName || 'N/A';
                                                    })(), border: [false, false, false, false], fontSize: 9, alignment: 'start'
                                                }

                                            ]
                                        ]
                                    },
                                    layout: {
                                        defaultBorder: false,
                                        paddingLeft: function (i) { return 4; },
                                        paddingRight: function (i) { return 4; },
                                        paddingTop: function (i) { return 4; },
                                        paddingBottom: function (i) { return 4; }
                                    }
                                }
                            ]
                        }
                    ]
                },

                {
                    table: {
                        headerRows: 1,
                        widths: ['auto', '*', '*', 'auto'],
                        body: [
                            [
                                { text: 'SR. NO.', style: 'tableHeader', border: [true, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                                { text: 'PRODUCT NAME', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                                { text: 'DESCRIPTION', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                                { text: 'QTY.', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                            ],
                            ...generateProductRows(processItem)
                        ]
                    },
                    margin: [0, 10, 0, 0] // Reduced table margin
                },
                {
                    width: '*',
                    stack: [
                        {
                            image: stampImg,
                            width: 150,
                            alignment: 'right'
                        },
                        {
                            text: 'Company Stamp & Sign',
                            alignment: 'right',
                            bold: true,
                            margin: [0, 5, 0, 0]
                        }
                    ],
                    margin: [0, 20, 0, 0] // Reduced stamp margin
                }
            );
        });

        // Check for bulk data
        const processbulkIds = AllDispatchProcess.find(process => process._id === dispatchProcessId);
        const bulkIds = processbulkIds?.ProcessData.map(p => p.bulkId).filter(Boolean);
        const bulkfiltered = AllDispatchProcess.filter(process =>
            process.ProcessData.some(data => bulkIds?.includes(data.bulkId))
        );

        if (bulkIds) {
            if (bulkfiltered.length > 0) {
                allPagesContent.push({ text: '', pageBreak: 'before' });
                allPagesContent.push(
                    {
                        columns: [
                            {
                                image: logoBase64,
                                width: 100,
                                margin: [0, 0, 0, 0]
                            },
                            // {
                            //     text: matchingDispatchProcess?.ProcessData?.[0]?.generatedNumber.includes('Return') ? 'RETURN CHALLAN' : 'DISPATCH CHALLAN',
                            //     style: 'header',
                            //     alignment: 'right',
                            //     margin: [0, 0, 0, 2],
                            //     decoration: 'underline',
                            //     decorationColor: '#FB9822'
                            // },
                        ],
                    }
                );
                allPagesContent.push({
                    text: 'Bulk Dispatch Details',
                    style: 'header',
                    margin: [0, 20, 0, 10]
                });

                {
                    bulkfiltered?.length > 0 ? (
                        bulkfiltered?.map((bulkItem, bulkIndex) => {
                            const matchingProcessData = bulkItem.ProcessData.filter(processData =>
                                bulkIds.includes(processData.bulkId) && processData.bulkId
                            );



                            return (
                                <Box key={bulkIndex} sx={{ padding: 2 }}>
                                    {matchingProcessData.map((processData, processIndex) => {
                                        const displayedKits = new Set();

                                        allPagesContent.push({
                                            text: `Details for ${processData.generatedNumber} - ${bulkItem?.marketData?.ConsumerName} (${bulkItem?.marketData?.fillNo})  ${processData.DispatchDate}`,
                                            style: 'subheader',
                                            margin: [0, 20, 0, 0],
                                            fontSize: 11,
                                        });

                                        const tableBody = [
                                            [
                                                { text: 'SR. NO.', style: 'tableHeader', border: [true, true, false, true], fontSize: 8, characterSpacing: 1 },
                                                { text: 'PRODUCT NAME', style: 'tableHeader', border: [false, true, false, true], fontSize: 8, characterSpacing: 1 },
                                                { text: 'DESCRIPTION', style: 'tableHeader', border: [false, true, false, true], fontSize: 8, characterSpacing: 1 },
                                                { text: 'QTY.', style: 'tableHeader', border: [false, true, false, true], fontSize: 8, characterSpacing: 1 },
                                            ]
                                            ,
                                            ...processData.DispatchDetails
                                                .map((detail, index) => {
                                                    let productName = 'N/A';




                                                    if (detail?.KitNo === 0) {
                                                        productName = detail?.DispatchProductNameData?.productName || 'N/A';
                                                    } else {
                                                        const kitProduct = kitproductdata?.find((k) => k?._id === detail.DispatchKitId);
                                                        if (kitProduct) {
                                                            if (displayedKits.has(detail.DispatchKitId)) {
                                                                return null; // Ignore duplicate kits
                                                            }
                                                            displayedKits.add(detail.DispatchKitId);
                                                            productName = kitProduct.productName || kitProduct.KitName || 'N/A';
                                                        }
                                                    }

                                                    return [
                                                        { text: (index + 1).toString(), fontSize: 9 },
                                                        { text: productName, fontSize: 9 },
                                                        { text: detail?.KitNo === 0 ? detail.DispatchDiscription || 'N/A' : 'N/A', fontSize: 9 },
                                                        { text: detail?.KitNo === 0 ? detail.DispatchQty?.toString() || 'N/A' : "1", fontSize: 9 },
                                                    ];
                                                })
                                                .filter(Boolean), // Remove null values
                                        ];

                                        allPagesContent.push({
                                            table: {
                                                headerRows: 1,
                                                widths: ['auto', '*', '*', 'auto'],
                                                body: tableBody,
                                            },
                                            margin: [0, 15, 0, 0],
                                        });

                                        return (
                                            <Box key={processIndex}>
                                                <Typography variant="h5" sx={{ marginBottom: 2 }}>
                                                    Bulk Dispatch Details for {processData.generatedNumber}
                                                </Typography>
                                            </Box>
                                        );
                                    })}
                                </Box>

                            );
                        })
                    ) : (
                        <Typography variant="h6" color="textSecondary" align="center">
                            No Bulk Dispatch Data Available.
                        </Typography>
                    )
                }
                allPagesContent.push({
                    width: '*',
                    stack: [
                        {
                            image: stampImg,
                            width: 150,
                            alignment: 'right'
                        },
                        {
                            text: 'Company Stamp & Sign',
                            alignment: 'right',
                            bold: true,
                            margin: [0, 5, 0, 0]
                        }
                    ],
                    margin: [0, 20, 0, 0] // Reduced stamp margin
                });
            }
        }
        const docDefinition = {
            content: allPagesContent,
            styles: {
                header: {
                    fontSize: 25,
                    bold: true,
                    color: '#1F2F58',
                    font: 'Lexend',
                },
                subheader: {
                    fontSize: 20,
                    bold: true,
                    margin: [0, 10, 0, 5],
                    font: 'Lexend',
                },
                tableHeader: {
                    bold: true,
                    color: 'white',
                    fillColor: '#293754',
                    font: 'Lexend',
                }
            },
            defaultStyle: {
                fontSize: 12,
                font: 'Lexend',
            }
        };


        return docDefinition;
    };

    const generateProductRows = (processItem) => {


        if (!processItem?.DispatchDetails) return [];
        return processItem.DispatchDetails.map((item, DataIndex) => {
            // const product = item.DispatchProductNameData;
            const qty = item.DispatchQty || 0;

            const product = item?.KitNo === 0 ?
                item.DispatchProductNameData || 'N/A' :
                kitproductdata?.find((k) => k?._id === item.DispatchKitId)
                ;

            return [
                { text: (DataIndex + 1).toString(), fontSize: 9 },
                { text: product?.productName || product?.KitName || 'N/A', fontSize: 9 },
                { text: item?.KitNo === 0 ? item.DispatchDiscription || 'N/A' : 'N/A', fontSize: 9 },
                { text: item?.KitNo === 0 ? qty.toString() || 'N/A' : 1, fontSize: 9 },
            ];
        });
    };

    useEffect(() => {
        const loadFonts = async () => {
            try {
                await getLexendFonts();
            } catch (error) {
                console.error('Failed to load fonts:', error);
            }
        };
        loadFonts();
    }, []);

    const downloadPDF = async () => {
        await getLexendFonts();



        if (selectedDispatchProcess.length > 0) {
            const allContent = [];

            for (const process of selectedDispatchProcess) {
                const marketData = fMarket.find(m => m._id === process.marketId);
                const fData = await processAllDispatchDetails(process.ProcessData);




                const docDefinition = await generatePdfContent(marketData, fData);
                allContent.push(...docDefinition.content);

                if (process !== selectedDispatchProcess[selectedDispatchProcess.length - 1]) {
                    allContent.push({ text: '', pageBreak: 'before' });
                }
            }




            const finalDocDefinition = {
                content: allContent,
                defaultStyle: {
                    font: 'Lexend',
                },
                styles: {
                    header: {
                        fontSize: 25,
                        bold: true,
                        color: '#1F2F58',
                        font: 'Lexend',
                    },
                    sectionHeader: {
                        fontSize: 16,
                        bold: true,
                        color: 'white',
                        fillColor: '#293754',
                        padding: 8,
                        font: 'Lexend',
                    },
                    tableHeader: {
                        bold: true,
                        color: 'white',
                        fillColor: '#293754',
                        font: 'Lexend',
                    }
                },
                defaultStyle: {
                    fontSize: 12
                }
            };
            pdfMake.createPdf(finalDocDefinition).download('multiple_dispatch_challans.pdf');
        } else {
            const matchingDispatchProcess = AllDispatchProcess.find(
                process => process.marketId === selectedPurchase?._id
            );



            const fData = await processAllDispatchDetails(matchingDispatchProcess.ProcessData);


            const docDefinition = await generatePdfContent(selectedPurchase, { ...matchingDispatchProcess, ProcessData: fData });
            pdfMake.createPdf(docDefinition).download('dispatch_challan.pdf');
        }
    };

    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedDispatchProcess, setSelectedDispatchProcess] = useState([]);




    const handleCheckboxChange = (id) => {
        setSelectedItems(prevSelected => {
            if (prevSelected.includes(id)) {
                const newSelected = prevSelected.filter(item => item !== id);
                setSelectedDispatchProcess(prevProcesses =>
                    prevProcesses.filter(process => process.marketId !== id)
                );

                return newSelected;
            } else {
                const newSelected = [...prevSelected, id];
                const matchingDispatchProcess = AllDispatchProcess.find(process => process.marketId === id);
                if (matchingDispatchProcess) {
                    setSelectedDispatchProcess(prevProcesses =>
                        [...prevProcesses, matchingDispatchProcess]
                    );
                }

                return newSelected;
            }
        });
    };

    const bulkDispatch = () => {
        if (selectedItems.length < 2) {
            alert("Please select at least two checkbox to proceed with bulk dispatch.");
            return;
        }
        const selectedMarketData = selectedItems.map(id =>
            fMarket.find(m => m._id === id)
        ).filter(Boolean);




        const processData = selectedItems.map(id => {
            const existingProcess = AllDispatchProcess.find(process => process.marketId === id);
            const smarket = fMarket.find(m => m._id === id);



            if (existingProcess) {
                return existingProcess;
            }

            return {
                marketId: id,
                ProcessData: [{
                    DebitCreditWarehouseName: '',
                    PurposeofDispatch: '',
                    generatedNumber: '',
                    DispatchDetails: [
                        {
                            DispatchCatogory: smarket.productData?.[0].mainCategory,
                            DispatchSubCatogory: smarket.productData?.[0].subCategory,
                            DispatchProductName: smarket.productData?.[0]._id,
                            DispatchKitId: '',
                            DispatchDiscription: smarket.productData?.[0].Desacription,
                            DispatchUnit: smarket.productData?.[0].unitOfMeasurement,
                            DispatchQty: '',
                        },
                        {
                            DispatchCatogory: smarket.inverterData?.[0].mainCategory,
                            DispatchSubCatogory: smarket.inverterData?.[0].subCategory,
                            DispatchProductName: smarket.inverterData?.[0]._id,
                            DispatchKitId: '',
                            DispatchDiscription: smarket.inverterData?.[0].Desacription,
                            DispatchUnit: smarket.inverterData?.[0].unitOfMeasurement,
                            DispatchQty: '',
                        }
                    ]
                }]
            };
        });

        navigate('/admin/bulk-dispatch', {
            state: {
                selectedDispatchProcess: processData,
                selectedMarketData
            }
        });
    };




    const processAllDispatchDetails = (data) => {



        return data.map(dispatchData => {
            const generatedNumber = dispatchData.generatedNumber;
            const dispatchDetails = dispatchData.DispatchDetails;
            const debitCreditWarehouseData = dispatchData.DebitCreditWarehouseData;

            const processedDispatchDetails = [];
            const seenKitNos = new Set(); // Keep track of seen KitNo values

            dispatchDetails.forEach(detail => {
                if (detail.DispatchKitId && seenKitNos.has(detail.KitNo)) {
                    return; // Skip if KitNo already seen
                }

                if (detail.DispatchKitId) {
                    seenKitNos.add(detail.KitNo);
                }

                const processedDetail = {
                    ...detail,
                    generatedNumber,
                    DebitCreditWarehouseData: debitCreditWarehouseData
                };

                if (detail.DispatchKitData) {
                    processedDetail.KitData = detail.DispatchKitData;
                }

                processedDispatchDetails.push(processedDetail);

            });

            return {
                generatedNumber,
                PurposeofDispatch: dispatchData.PurposeofDispatch,
                DispatchSuggestionId: dispatchData.DispatchSuggestionId,
                DispatchDate: dispatchData.DispatchDate,
                DebitCreditWarehouseName: dispatchData.DebitCreditWarehouseName,
                DebitCreditWarehouseData: dispatchData.DebitCreditWarehouseData,
                DispatchModelTransport: dispatchData.DispatchModelTransport,
                DispatchRemarks: dispatchData.DispatchRemarks,
                createProcessDate: dispatchData.createProcessDate,
                DispatchDetails: processedDispatchDetails
            };
        });
    }

    return (
        <Box m="2px" sx={{ overflow: isMobileee ? 'auto' : 'hidden', }}>
            <Header
                title="DISPATCH PROCESS"
                subtitle="Manage Your Dispatch Process Here"
            />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginTop: "20px",
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", mb: { xs: 2, md: 0 }, flexGrow: 1 }}>
                    <FormControl size="small" sx={{ mr: 2 }}>
                        <Select
                            value={selectedStatus}
                            onChange={(event) => {
                                setSelectedStatus(event.target.value);
                            }}
                            sx={{
                                minWidth: '200px',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#566585',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#566585',
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#566585',
                                    borderWidth: '2px',
                                },
                            }}
                        >
                            <MenuItem value="0">All Status ({fMarket.length})</MenuItem>
                            <MenuItem value="Dispatch on Credit">Dispatch on Credit ({statusCounts["Dispatch on Credit"]})</MenuItem>
                            <MenuItem value="Dispatch Pending">Dispatch Pending ({statusCounts["Dispatch Pending"]})</MenuItem>
                            <MenuItem value="Half Material Dispatch">Half Material Dispatch ({statusCounts["Half Material Dispatch"]})</MenuItem>
                            <MenuItem value="Dispatch Done">Dispatch Done ({statusCounts["Dispatch Done"]})</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        width: { xs: '100%', md: '300px' },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: '#566585',
                            },
                            '&:hover fieldset': {
                                borderColor: '#566585',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#566585',
                                borderWidth: '2px',
                            },
                        },
                    }}
                />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button variant="contained" color="primary" onClick={bulkDispatch}>Bulk Dispatch</Button>
            </Box>


            {filteredMarket.length > 0 ? (
                [...filteredMarket].sort((a, b) => {
                    const paymentStatusA = getPaymentStatus(a);
                    const paymentStatusB = getPaymentStatus(b);

                    const liasoningA = filteredLiasoning.find(l => l.fillNo === a.fillNo);
                    const liasoningB = filteredLiasoning.find(l => l.fillNo === b.fillNo);

                    const hasFileInfoA = liasoningA && liasoningA.fileNo && liasoningA.fileDate;
                    const hasFileInfoB = liasoningB && liasoningB.fileNo && liasoningB.fileDate;

                    if (paymentStatusA === 'full' || paymentStatusA === 'partial') {
                        if (paymentStatusB !== 'full' && paymentStatusB !== 'partial') return -1;
                    }
                    if (paymentStatusB === 'full' || paymentStatusB === 'partial') {
                        if (paymentStatusA !== 'full' && paymentStatusA !== 'partial') return 1;
                    }
                    if ((paymentStatusA === 'full' || paymentStatusA === 'partial') &&
                        (paymentStatusB === 'full' || paymentStatusB === 'partial')) {
                        const dateA = new Date(a.Date);
                        const dateB = new Date(b.Date);
                        return dateB - dateA;
                    }
                    if (hasFileInfoA && !hasFileInfoB) return -1;
                    if (!hasFileInfoA && hasFileInfoB) return 1;

                    if (hasFileInfoA && hasFileInfoB) {
                        const dateA = new Date(liasoningA.fileDate);
                        const dateB = new Date(liasoningB.fileDate);
                        return dateB - dateA;
                    }
                    const dateA = new Date(a.Date);
                    const dateB = new Date(b.Date);
                    return dateB - dateA;
                }).map((v) => {
                    const completedSteps = getCompletedSteps(v);
                    const dispatchProcess = AllDispatchProcess?.find(process => process?.marketId === v?._id);
                    return (
                        <Box key={v._id} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox
                                checked={selectedItems.includes(v._id)}
                                onChange={() => handleCheckboxChange(v._id)}
                                sx={{
                                    mt: 3,
                                    pointerEvents: v.liasoningData[0]?.status === 'Enabled' ? 'none' : 'auto',
                                    opacity: v.liasoningData[0]?.status === 'Enabled' ? 0.5 : 1,
                                    color: theme.palette.mode === 'dark' ? 'white' : '#134670',
                                    '&.Mui-checked': {
                                        color: theme.palette.mode === 'dark' ? '#6da2cd' : '#134670',
                                    },
                                }}
                            />
                            <Box className="padding_box" sx={{
                                m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2, bgcolor: theme.palette.mode === 'dark' ? '#293040' : "#E5F1FD", color: theme.palette.mode === 'dark' ? 'white' : "black", flex: 1,
                                overflowX: 'auto',
                                pointerEvents: v.liasoningData[0]?.status === 'Enabled' ? 'none' : 'auto',
                                opacity: v.liasoningData[0]?.status === 'Enabled' ? 0.5 : 1
                            }} key={v._id}
                            >
                                <Grid container item >
                                    {!isMobile && (
                                        <Grid item sx={{ flexGrow: 1 }}>
                                            <Box sx={{ whiteSpace: 'pre-line', display: 'flex', flexGrow: 1 }}>
                                                <Box sx={{ width: '180px' }}>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Customer File No List</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Customer Name</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>System Size</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Address</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>City</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600' }}>Dealer Name</li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ width: '550px' }}>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.fillNo}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.ConsumerName}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.SystemSizeKw}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.Address}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.City_Village}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.userData?.[0]?.name}
                                                        </li>
                                                    </ul>
                                                </Box>
                                                <Box sx={{ width: '210px' }}>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Customer Pending Payment</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Marketing Warehouse Name</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Date of Dispatch</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Solar PV</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Solar Inverter</li>
                                                    </ul>
                                                </Box>
                                                <ul style={{ textWrap: "nowrap" }}>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {(() => {
                                                            if (!v.AccountData || v.AccountData.length === 0) {
                                                                return 'No Account Data Available';
                                                            }

                                                            const accountDetails = v.AccountData[0]?.AccountDetails || [];
                                                            const totalAccountAmount = accountDetails.reduce(
                                                                (sum, account) => sum + parseFloat(account.AccountAmount || 0),
                                                                0
                                                            );

                                                            const remainingAmount = parseFloat(v.TotalAmount || 0) - totalAccountAmount;

                                                            return remainingAmount > 0
                                                                ? `${remainingAmount}`
                                                                : 'Fully Paid';
                                                        })()}
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {v?.wareHouseData[0]?.wareHouseName}
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {AllDispatchProcess.find(process => process.marketId === v._id)?.ProcessData
                                                            ?.map(data => format(new Date(data.DispatchDate), 'dd-MM-yyyy')).join(', ') || 'N/A'}
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {v.productData?.[0]?.productName}
                                                    </li>
                                                    <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                        {v.inverterData?.[0]?.productName}
                                                    </li>
                                                </ul>
                                                <Box sx={{ flexGrow: 1 }}>
                                                    <Grid sx={{ marginBottom: 2, display: 'flex', alignItems: 'center', justifyContent: "flex-end", flexGrow: 1 }}>
                                                        <IconButton aria-label="print" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                                                            onClick={() => handlePrint(v, dispatchProcess?._id)}
                                                        >
                                                            <PrintIcon />
                                                        </IconButton>
                                                        <IconButton aria-label="edit" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                                                            onClick={() => handleEdit(v, dispatchProcess?._id)}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                    </Grid>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    )}

                                    {isMobile ? (
                                        <>
                                            <Grid item>
                                                <Box sx={{ whiteSpace: 'pre-line', display: 'flex' }}>
                                                    <Box sx={{ width: '210px' }}>
                                                        <ul>
                                                            <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Customer File No List</li>
                                                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Customer Name</li>
                                                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>System Size</li>
                                                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Address</li>
                                                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>City</li>
                                                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Dealer Name</li>
                                                        </ul>
                                                    </Box>
                                                    <Box sx={{ width: '300px' }}>
                                                        <ul>
                                                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                                {v.fillNo}
                                                            </li>
                                                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                                {v.ConsumerName}
                                                            </li>
                                                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                                {v.SystemSizeKw}
                                                            </li>
                                                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                                {v.Address}
                                                            </li>
                                                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                                {v.City_Village}
                                                            </li>
                                                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                                {v.userData?.[0]?.name}
                                                            </li>
                                                        </ul>
                                                    </Box>
                                                    <ul>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Customer Pending Payment</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Marketing Warehouse Name</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Warehouse Name</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Date of Dispatch</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Solar PV</li>
                                                        <li style={{ listStyleType: 'none', fontWeight: '600', textWrap: "nowrap" }}>Solar Inverter</li>
                                                    </ul>
                                                    <ul style={{ textWrap: "nowrap" }}>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {(() => {
                                                                if (!v.AccountData || v.AccountData.length === 0) {
                                                                    return 'No Account Data Available';
                                                                }

                                                                const accountDetails = v.AccountData[0]?.AccountDetails || [];
                                                                const totalAccountAmount = accountDetails.reduce(
                                                                    (sum, account) => sum + parseFloat(account.AccountAmount || 0),
                                                                    0
                                                                );

                                                                const remainingAmount = parseFloat(v.TotalAmount || 0) - totalAccountAmount;

                                                                return remainingAmount > 0
                                                                    ? `${remainingAmount}`
                                                                    : 'Fully Paid';
                                                            })()}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.wareHouseName}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {(() => {
                                                                const processWarehouse = AllDispatchProcess.find(
                                                                    (process) => process.marketId === v._id
                                                                );

                                                                if (!processWarehouse?.ProcessData) return "N/A";

                                                                const warehouseNames = processWarehouse.ProcessData.map(
                                                                    (data) => data.DebitCreditWarehouseData?.wareHouseName
                                                                ).filter(Boolean);

                                                                return warehouseNames.length ? warehouseNames.join(", ") : "N/A";
                                                            })()}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {AllDispatchProcess.find(process => process.marketId === v._id)?.ProcessData
                                                                ?.map(data => format(new Date(data.DispatchDate), 'dd-MM-yyyy')).join(', ') || 'N/A'}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.productData?.[0]?.productName}
                                                        </li>
                                                        <li style={{ listStyleType: 'none' }}>: &nbsp;
                                                            {v.inverterData?.[0]?.productName}
                                                        </li>
                                                    </ul>
                                                    <Box sx={{ textAlign: 'right', ml: 4 }}>
                                                        <Grid sx={{ textAlign: 'start', marginBottom: 2, display: 'flex', alignItems: 'center' }}>
                                                            <Grid sx={{ marginBottom: 2, display: 'flex', alignItems: 'center', justifyContent: "flex-end", flexGrow: 1 }}>
                                                                <IconButton aria-label="print" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                                                                    onClick={() => handlePrint(v, dispatchProcess?._id)}
                                                                >
                                                                    <PrintIcon />
                                                                </IconButton>
                                                                <IconButton aria-label="edit" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                                                                    onClick={() => handleEdit(v, dispatchProcess?._id)}
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </>
                                    ) : (
                                        <>

                                        </>
                                    )}
                                </Grid>

                                {
                                    isMobile ? (
                                        <MobileStepper
                                            steps={steps}
                                            activeStep={activeStep}
                                            completedSteps={completedSteps}
                                        />
                                    ) : (
                                        <Stepper
                                            className='round_r'
                                            sx={{ mt: 3 }}
                                            alternativeLabel
                                            connector={<ColorlibConnector />}
                                        >
                                            {steps.map((label, index) => {
                                                const stepNumber = index + 1;
                                                const isStepCompleted = completedSteps[stepNumber];
                                                return (
                                                    <Step key={label}
                                                        completed={isStepCompleted}
                                                    >
                                                        <StepLabel
                                                            StepIconComponent={ColorlibStepIcon}
                                                            StepIconProps={{
                                                                completed: isStepCompleted
                                                            }}
                                                        >
                                                            <Typography style={{
                                                                color: isStepCompleted ? theme.palette.mode === 'dark' ? '#6da2cd' : "#165e99" : theme.palette.text.primary,
                                                                fontWeight: '600'
                                                            }}>
                                                                {label}
                                                            </Typography>
                                                        </StepLabel>
                                                    </Step>
                                                );
                                            })}
                                        </Stepper>
                                    )
                                }
                            </Box>
                        </Box>

                    )
                })
            ) : (
                <Box>
                    <Typography variant="h5" color="textSecondary" align="center">
                        No Results Found. Please Try a Different Search Term.
                    </Typography>
                </Box>
            )}

            {/* ...........................  1ST PDF for Single Dispatch Process () .............................. */}
            <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
                <DialogContent>
                    {(() => {
                        const matchingDispatchProcess = AllDispatchProcess.find(process => process.marketId === selectedPurchase?._id);
                        const processbulkIds = AllDispatchProcess.find(process => process._id === dispatchProcessId);
                        const bulkIds = processbulkIds?.ProcessData.map(p => p.bulkId).filter(Boolean);

                        const bulkfiltered = AllDispatchProcess.filter(process =>
                            process.ProcessData.some(data => bulkIds?.includes(data.bulkId))
                        );

                        if (!matchingDispatchProcess?.ProcessData?.length) {
                            return (
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    minHeight: '100px'
                                }}>
                                    <Typography variant="h5" color="textSecondary">
                                        No PDF Available
                                    </Typography>
                                </Box>
                            );
                        }

                        return (
                            <>
                                {processAllDispatchDetails(matchingDispatchProcess.ProcessData).map((item, index) => (
                                    <Box key={index} sx={{ padding: 2 }} ref={printRef}>
                                        <Grid container justifyContent="space-between" alignItems="center" sx={{ marginBottom: 4 }}>
                                            <Grid item xs={12} sm={6}>
                                                <Box
                                                    component="img"
                                                    className='pdf-logo'
                                                    src={(theme.palette.mode === "dark" ? '../../assets/images/logo/dark-logo.png' : '../../assets/images/logo/logo.svg')}
                                                    alt="Tvarit Energy LLP Logo"
                                                    sx={{ width: { xs: '100%', sm: '150px' }, maxWidth: '150px' }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ textAlign: 'right', marginBottom: 2 }}>
                                                    <Typography
                                                        variant="h5"
                                                        className="process-order-title"
                                                        sx={{
                                                            fontWeight: 'bold',
                                                            fontSize: '25px',
                                                            letterSpacing: '5px',
                                                            color: theme.palette.mode === "dark" ? 'white' : '#1F2F58',
                                                            position: 'relative',
                                                            display: 'inline-block',
                                                            borderBottom: '2px solid #FB9822',
                                                            paddingBottom: '4px'
                                                        }}
                                                    >
                                                        <Typography variant="h5" sx={{ fontSize: window.innerWidth <= 425 ? '22px' : '25px' }}>
                                                            {matchingDispatchProcess?.ProcessData?.[index]?.ProcessData?.[index]?.generatedNumber.includes('Return') ? 'RETURN CHALLAN' : 'DISPATCH CHALLAN'}
                                                        </Typography>
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'flex-start', height: '100%' }}>
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>CUSTOMER DETAILS</Typography>
                                                </Box>
                                                <Grid container direction="column" spacing={1} sx={{ marginTop: '10px' }}>
                                                    <Grid item container>
                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Customer Name</Typography></Grid>
                                                        <Grid item xs={1}><Typography>:</Typography></Grid>
                                                        <Grid item xs={7}><Typography>{selectedPurchase?.ConsumerName + ' (' + selectedPurchase?.fillNo + ')' || 'N/A'}</Typography></Grid>
                                                    </Grid>
                                                    <Grid item container>
                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Customer Address</Typography></Grid>
                                                        <Grid item xs={1}><Typography>:</Typography></Grid>
                                                        <Grid item xs={7}><Typography>{selectedPurchase?.Address || 'N/A' || 'N/A'}</Typography></Grid>
                                                    </Grid>
                                                    <Grid item container>
                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Customer Mobile No</Typography></Grid>
                                                        <Grid item xs={1}><Typography>:</Typography></Grid>
                                                        <Grid item xs={7}><Typography>{selectedPurchase?.PhoneNumber || 'N/A'}</Typography></Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start' }}>
                                                <Grid item container>
                                                    <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;</Typography></Grid>
                                                    <Grid item xs={8}>
                                                        <Typography sx={{ fontWeight: '600' }}>
                                                            {format(new Date(matchingDispatchProcess?.ProcessData?.[index]?.DispatchDate), 'dd-MM-yyyy')}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>

                                                <Grid item container>
                                                    <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Dispatch Number &nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;</Typography></Grid>
                                                    <Grid item xs={8}>
                                                        <Typography sx={{ fontWeight: '600' }}>
                                                            {matchingDispatchProcess?.ProcessData?.[index]?.generatedNumber || 'N/A'}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>TVARIT ADDRESS</Typography>
                                                </Box>
                                                <Box sx={{ marginTop: '10px', wordSpacing: '2px' }}>
                                                    <Grid container direction="column" spacing={1}>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Company Name</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '700' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '700' }}>{orderDetails.billTo.companyName}</Typography></Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Address</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.address}</Typography></Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>GST No</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>24AAQFT9592E1ZK</Typography></Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Contact No</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>+91 97245 71843</Typography></Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Email</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>info@tvaritenergy.in</Typography></Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Website</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>www.tvaritenergy.in</Typography></Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>SHIP FROM</Typography>
                                                </Box>
                                                <Box sx={{ marginTop: '10px', wordSpacing: '2px' }} >
                                                    <Grid container direction="column" spacing={1}>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Company Name</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}>
                                                                <Typography sx={{ fontWeight: '600' }}>
                                                                    {(() => {
                                                                        const ProcessWarehouse = matchingDispatchProcess?.ProcessData?.[index];


                                                                        // if (!ProcessWarehouse) return 'N/A';

                                                                        // 


                                                                        const warehouseName = ProcessWarehouse.DebitCreditWarehouseData?.wareHouseName || 'N/A';



                                                                        return warehouseName;
                                                                    })()}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        <TableContainer sx={{ marginTop: 2 }}>
                                            <Table>
                                                <TableHead sx={{ backgroundColor: '#293754' }}>
                                                    <TableRow>
                                                        <TableCell sx={{ color: 'white' }}>SR. NO.</TableCell>
                                                        <TableCell sx={{ color: 'white' }}>PRODUCT NAME</TableCell>
                                                        <TableCell sx={{ color: 'white' }}>DESCRIPTION</TableCell>
                                                        <TableCell sx={{ color: 'white' }}>HSN CODE</TableCell>
                                                        <TableCell sx={{ color: 'white' }}>QTY.</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(() => {

                                                        return item.DispatchDetails
                                                            ?.map((item, DataIndex) => {

                                                                const productName = item?.KitNo === 0 ?
                                                                    item.DispatchProductNameData || 'N/A' :
                                                                    kitproductdata?.find((k) => k?._id === item.DispatchKitId)
                                                                    ;

                                                                return (
                                                                    <TableRow key={DataIndex}>
                                                                        <TableCell sx={{ fontWeight: '600' }}>{DataIndex + 1}</TableCell>
                                                                        <TableCell sx={{ fontWeight: '600' }}>{productName?.productName || productName?.KitName}</TableCell>
                                                                        <TableCell sx={{ fontWeight: '600' }}>{item?.KitNo === 0 ? item.DispatchDiscription : 'N/A'}</TableCell>
                                                                        <TableCell sx={{ fontWeight: '600' }}>{productName?.HSNcode || 'N/A'}</TableCell>
                                                                        <TableCell sx={{ fontWeight: '600' }}>{item?.KitNo === 0 ? item.DispatchQty : 1}</TableCell>

                                                                    </TableRow>
                                                                );
                                                            }) || [];
                                                    })()}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        <Grid container justifyContent="flex-end" sx={{ marginTop: -2 }}>
                                            <Grid item>
                                                <Box
                                                    component="img"
                                                    className='stamp-sign'
                                                    src={'../../assets/images/stamp/stamp-1.svg'}
                                                    alt="Tvarit Energy LLP stamp"
                                                    sx={{ width: 150 }}
                                                />
                                                <Typography variant="body1" sx={{ fontWeight: '600' }}>Company Stamp & Sign</Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))}

                                {(bulkIds && bulkIds.length > 0) &&
                                    <Box>
                                        <Grid container justifyContent="space-between" alignItems="center" sx={{ marginBottom: 4 }}>
                                            <Grid item xs={12} sm={6}>
                                                <Box
                                                    component="img"
                                                    className='pdf-logo'
                                                    src={(theme.palette.mode === "dark" ? '../../assets/images/logo/dark-logo.png' : '../../assets/images/logo/logo.svg')}
                                                    alt="Tvarit Energy LLP Logo"
                                                    sx={{ width: { xs: '100%', sm: '150px' }, maxWidth: '150px' }}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Typography variant="h2" sx={{ color: theme.palette.text.primary, fontWeight: '700' }}>
                                            Bulk Dispatch Details
                                        </Typography>




                                        {bulkfiltered?.length > 0 ? (
                                            bulkfiltered?.map((bulkItem, bulkIndex) => {
                                                const matchingProcessData = bulkItem.ProcessData.filter(processData =>
                                                    bulkIds.includes(processData.bulkId) && processData.bulkId
                                                );

                                                return (
                                                    <Box key={bulkIndex} sx={{ padding: 2, paddingTop: 0 }}>
                                                        {matchingProcessData.map((processData, processIndex) => {
                                                            const displayedKits = new Set(); // Move it inside this map to persist per processData

                                                            return (
                                                                <Box key={processIndex}>
                                                                    <Typography variant="h5" sx={{ marginBottom: 2, marginTop: 2 }}>
                                                                        {`Details for ${processData.generatedNumber} - ${bulkItem?.marketData?.ConsumerName} (${bulkItem?.marketData?.fillNo}) ${format(new Date(processData.DispatchDate), 'dd-MM-yyyy')}`}
                                                                    </Typography>
                                                                    <TableContainer>
                                                                        <Table>
                                                                            <TableHead sx={{ backgroundColor: '#293754' }}>
                                                                                <TableRow>
                                                                                    <TableCell sx={{ color: 'white', textAlign: 'center', padding: '10px' }}>SR. NO.</TableCell>
                                                                                    <TableCell sx={{ color: 'white', textAlign: 'center', padding: '10px' }}>PRODUCT NAME</TableCell>
                                                                                    <TableCell sx={{ color: 'white', textAlign: 'center', padding: '10px' }}>DESCRIPTION</TableCell>
                                                                                    <TableCell sx={{ color: 'white', textAlign: 'center', padding: '10px' }}>HSN CODE</TableCell>
                                                                                    <TableCell sx={{ color: 'white', textAlign: 'center', padding: '10px' }}>QTY.</TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {processData.DispatchDetails.map((detail, detailIndex) => {
                                                                                    let productName = 'N/A';

                                                                                    if (detail?.KitNo === 0) {
                                                                                        productName = detail.DispatchProductNameData || 'N/A';
                                                                                    } else {
                                                                                        const kitProduct = kitproductdata?.find((k) => k?._id === detail.DispatchKitId);

                                                                                        if (kitProduct) {
                                                                                            if (displayedKits.has(detail.DispatchKitId)) {
                                                                                                return null; // Skip rendering duplicate KitNo entries
                                                                                            }
                                                                                            displayedKits.add(detail.DispatchKitId);
                                                                                            productName = kitProduct;
                                                                                        }
                                                                                    }

                                                                                    return (
                                                                                        <TableRow key={`${bulkIndex}-${detailIndex}`}>
                                                                                            <TableCell sx={{ fontSize: '13px', textAlign: 'center', padding: '10px' }}>{detailIndex + 1}</TableCell>
                                                                                            <TableCell sx={{ fontSize: '13px', textAlign: 'center', padding: '10px' }}>{productName?.productName || productName?.KitName}</TableCell>
                                                                                            <TableCell sx={{ fontSize: '13px', textAlign: 'center', padding: '10px' }}>{detail?.KitNo === 0 ? detail.DispatchDiscription : 'N/A'}</TableCell>
                                                                                            <TableCell sx={{ fontSize: '13px', textAlign: 'center', padding: '10px' }}>{detail?.KitNo === 0 ? detail.DispatchUnit : 'N/A'}</TableCell>
                                                                                            <TableCell sx={{ fontSize: '13px', textAlign: 'center', padding: '10px' }}>{detail?.KitNo === 0 ? detail.DispatchQty : 1}</TableCell>
                                                                                        </TableRow>
                                                                                    );
                                                                                })}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Box>
                                                            );
                                                        })}
                                                    </Box>
                                                );
                                            })
                                        ) : (
                                            <Typography variant="h6" color="textSecondary" align="center">
                                                No Bulk Dispatch Data Available.
                                            </Typography>
                                        )}


                                        <Grid container justifyContent="flex-end" sx={{ marginTop: -2 }}>
                                            <Grid item>
                                                <Box
                                                    component="img"
                                                    className='stamp-sign'
                                                    src={'../../assets/images/stamp/stamp-1.svg'}
                                                    alt="Tvarit Energy LLP stamp"
                                                    sx={{ width: 150 }}
                                                />
                                                <Typography variant="body1" sx={{ fontWeight: '600' }}>Company Stamp & Sign</Typography>
                                            </Grid>
                                        </Grid>
                                    </Box >
                                }
                            </>
                        );
                    })()}
                </DialogContent >
                <DialogActions>
                    <Button
                        onClick={downloadPDF}
                        sx={{ color: theme.palette.text.primary }}
                        disabled={!AllDispatchProcess.find(process => process.marketId === selectedPurchase?._id)?.ProcessData?.length}
                    >
                        Download PDF
                    </Button>
                    <Button onClick={handleCloseDialog} sx={{ color: theme.palette.text.primary }}>Close</Button>
                </DialogActions>
            </Dialog>

        </Box >
    )
}

export default DispatchProcess